import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { AddLeader } from "./modal";
import { ViewEditLeader } from "./viewEditModal";
import { Footer } from "../../../layout/footer";
import { Loading } from "../../constant";
import { options } from "../../../api";
import { boundaryCRUD } from "../../../actions/boundary";
import { authCRUD } from "../../../actions/auth";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export const LeaderContent = () => {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [selectedLeader, setSelectedLeader] = useState(null);
  const [mode, setMode] = useState("view");
  const stateBoundaries = useSelector((state) => state.boundaries);


  useEffect(() => {
    setTimeout(() => {
      boundaryCRUD
        .loadBoundaryLeader(postsPerPage, nextPage, value)
        .then((resp) => {
          setCount(resp.data.count);
          setData(resp.data.results);
          setPageCount(Math.ceil(resp.data.count / postsPerPage));
        })
        .finally(() => {});
    }, 2000);
  }, [page, postsPerPage, value, index]);

  const handleChangePage = (event) => {
    setData([]);
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = (selectedOption) => {
    setData([]);
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0);
  };

  const handleSearch = (event) => {
    setData([]);
    setValue(event.target.value);
  };

  // Block / unblock the leader's login account (toggles User.is_active).
  const handleToggleBlock = (dt) => {
    if (!dt.user_account) {
      toast.error("This leader has no login account.", { autoClose: 5000 });
      return;
    }
    const action = dt.account_active
      ? authCRUD.updateUserNotActive(dt.user_account)
      : authCRUD.updateUserActive(dt.user_account);
    action
      .then(() => {
        toast.success(
          dt.account_active ? "Account blocked." : "Account unblocked.",
          { autoClose: 5000 }
        );
        setIndex(index + 1);
      })
      .catch((error) => {
        toast.error(error?.message || "Action failed", { autoClose: 5000 });
      });
  };

  return (
    <>
      <AddLeader setIndex={setIndex} index={index} />
      <ViewEditLeader
        leader={selectedLeader}
        mode={mode}
        setIndex={setIndex}
        index={index}
      />
      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0">Shehia Leaders</h4>

                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item">
                        <a href="#">Leader</a>
                      </li>
                      <li class="breadcrumb-item active">List</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="card">
                  <div class="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <input
                          className="form-control"
                          value={value}
                          onChange={handleSearch}
                          placeholder="search"
                        />
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          <div className="col-auto">
                            <Link
                              to={"/new"}
                              className="btn btn-soft-primary"
                              data-bs-toggle="modal"
                              data-bs-target=".addModal"
                            >
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp;
                              New Leader
                            </Link>
                          </div>
                          {/* <div className="col-auto">
                            <Link to={'/new'} className="btn btn-soft-info" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg">
                              <i className="bi bi-upload bi-lg"></i> &nbsp; Upload Leader
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <table
                      id="scroll-vertical"
                      class="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Leader Full Name</th>
                          <th data-ordering="true">Username</th>
                          <th data-ordering="true">Date of Birth</th>
                          <th data-ordering="true">Email</th>
                          <th data-ordering="true">Phone</th>
                          <th data-ordering="true">Boundary</th>
                          <th data-ordering="true">Status</th>
                          <th className="d-flex justify-content-center">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((dt, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{dt.full_name ? dt.full_name : "N/A"}</td>
                            <td>{dt.username ? dt.username : "N/A"}</td>
                            <td>
                              {dt.dob
                                ? moment(dt.dob).format("D MMM, YYYY")
                                : "N/A"}
                            </td>
                            <td>
                              {dt.emaila_ddress ? dt.emaila_ddress : "N/A"}
                            </td>
                            <td>{dt.phone_number ? dt.phone_number : "N/A"}</td>
                            <td>
                              {dt.leader_type && (
                                <span className="badge bg-soft-primary text-primary me-1">
                                  {dt.leader_type}
                                </span>
                              )}
                              {dt.boundary_name
                                ? dt.boundary_name
                                : Number.isInteger(dt.boundary_id)
                                ? stateBoundaries.boudaryList.filter(
                                    (boundary) => boundary.id === dt.boundary_id
                                  )[0]?.["boundary_name"] || "N/A"
                                : "N/A"}
                            </td>
                            <td>
                              {dt.is_active ? (
                                <span class="badge badge-soft-success">
                                  Active
                                </span>
                              ) : (
                                <span class="badge badge-soft-danger">
                                  Not Active
                                </span>
                              )}
                              {dt.user_account &&
                                dt.account_active === false && (
                                  <span className="badge badge-soft-dark ms-1">
                                    Blocked
                                  </span>
                                )}
                            </td>
                            <td className="text-center">
                              <div className="dropdown d-inline-block">
                                <button
                                  className="btn btn-soft-secondary btn-sm dropdown"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="ri-more-2-fill align-middle"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end">
                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      data-bs-toggle="modal"
                                      data-bs-target=".viewEditLeaderModal"
                                      onClick={() => {
                                        setSelectedLeader(dt);
                                        setMode("view");
                                      }}
                                    >
                                      <i className="ri-eye-fill align-bottom me-2 text-muted"></i>{" "}
                                      View
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item edit-item-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target=".viewEditLeaderModal"
                                      onClick={() => {
                                        setSelectedLeader(dt);
                                        setMode("edit");
                                      }}
                                    >
                                      <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                                      Edit
                                    </button>
                                  </li>
                                  <li>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() => handleToggleBlock(dt)}
                                    >
                                      {dt.account_active ? (
                                        <>
                                          <i className="ri-lock-fill align-bottom me-2 text-danger"></i>{" "}
                                          Block account
                                        </>
                                      ) : (
                                        <>
                                          <i className="ri-lock-unlock-fill align-bottom me-2 text-success"></i>{" "}
                                          Unblock account
                                        </>
                                      )}
                                    </button>
                                  </li>
                                </ul>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="row">{!data.length && <Loading />}</div>
                    <div className="row">
                      <div className="col-md-2">
                        <p>
                          <span>Showing </span>
                          <span>{data.length}</span> of <span>{count}</span>{" "}
                          entries
                        </p>
                      </div>
                      <div className="col-md-5"></div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select
                              options={options}
                              defaultValue={options[1]}
                              onChange={handleChange}
                            />
                          </div>
                          <div className="col-auto paginate">
                            <ReactPaginate
                              previousLabel={
                                <i className="las la-angle-double-left la-lg"></i>
                              }
                              nextLabel={
                                <i className="las la-angle-double-right la-lg"></i>
                              }
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
